import { useQuery } from '@tanstack/react-query'
import { useResellerContext } from '../useResellerContext'
import { QUERY_DATA } from 'src/service'
import { getBestSellers } from 'src/service/bestSellersService'

export const useBestSellers = () => {
  const resellerContext = useResellerContext()
  const { data, isLoading } = useQuery(
    [QUERY_DATA.BEST_SELLERS],
    async () => {
      const bestSellersResponse = await getBestSellers({
        reseller: resellerContext?.reseller,
        pagination: { page_size: 12 },
        isGenericReseller: Boolean(resellerContext?.isGenericUser),
      })

      return bestSellersResponse.data.products
    },
    {
      refetchOnWindowFocus: false,
    },
  )

  return {
    isLoading,
    data,
  }
}
